import Icon from '../components/Icon.vue'

Icon.register({
  sync: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M440.9 12.6c-0.3-6.8 5.1-12.6 12-12.6h47.4c6.6 0 12 5.4 12 12v200.3c0 6.6-5.4 12-12 12h-200.3c-6.6 0-12-5.4-12-12v-47.4c0-6.9 5.7-12.3 12.6-12l101.5 4.9c-31.6-46.9-85.2-77.8-146.1-77.8-83.1 0-152.6 57.4-171.1 134.7-1.3 5.4-6.1 9.3-11.7 9.3h-49.1c-7.5 0-13.2-6.8-11.8-14.2 21.6-114.9 122.5-201.8 243.7-201.8 75.7 0 143.4 33.9 188.9 87.3zM256 432c83.1 0 152.6-57.4 171.1-134.7 1.3-5.4 6.1-9.3 11.7-9.3h49.1c7.5 0 13.2 6.8 11.8 14.2-21.6 114.9-122.5 201.8-243.7 201.8-75.6 0-143.3-33.8-188.8-87.2l4.1 82.6c0.3 6.9-5.1 12.6-12 12.6h-47.4c-6.6 0-12-5.4-12-12v-200.3c0-6.6 5.4-12 12-12h200.3c6.6 0 12 5.4 12 12v47.4c0 6.9-5.7 12.3-12.6 12l-101.9-4.9c31.6 46.9 85.2 77.8 146.1 77.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-awesome/icons/sync.js
// module id = null
// module chunks = 